var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDate = function SvgDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.62 4.82q-.558.055-.966.11A1.58 1.58 0 0 0 3.28 6.287C3.148 7.218 3 8.699 3 10.693s.148 3.474.281 4.406a1.58 1.58 0 0 0 1.373 1.356c1.024.137 2.743.294 5.221.294s4.196-.157 5.222-.294a1.58 1.58 0 0 0 1.372-1.356c.133-.932.281-2.413.281-4.406 0-1.994-.148-3.475-.281-4.406a1.58 1.58 0 0 0-1.373-1.357q-.481-.063-.966-.11M11.512 4.66a54 54 0 0 0-3.274 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.516 5.053c.014.68.461 1.209 1.142 1.22h.326c.681-.011 1.129-.54 1.143-1.22a20 20 0 0 0 0-.832c-.014-.68-.462-1.21-1.143-1.22a11 11 0 0 0-.326 0c-.68.01-1.128.54-1.142 1.22a20 20 0 0 0 0 .832M5.622 5.053c.014.68.46 1.209 1.142 1.22h.326c.68-.011 1.128-.54 1.142-1.22a20 20 0 0 0 0-.832c-.014-.68-.461-1.21-1.142-1.22a11 11 0 0 0-.326 0c-.681.01-1.128.54-1.142 1.22q-.009.415 0 .832"
  }))));
};
export default SvgDate;